import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy } from "react-table";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { Button, Checkbox, Grid, TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import PaginationAndSearching from "../components/Pagination Component/paginationAndSearching";
import SkeletonTableRow from "../components/SkeltonTable/skeletonTable";
import { currencyFormat } from "../../function/commonFunction";
import { toast } from "react-toastify";
import { InputAdornment } from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { CurrencyRupee } from "@mui/icons-material";
import dayjs from "dayjs";
import { updatePaymentAdviceApi } from "../../service/bankApi/updatePaymentAdviceApi";

export const PaymentAdviceTable = ({
  column,
  rowsArr,
  handleSearchPagination,
  searchValuePagination,
  pageSizePagination,
  handleChangeRowsPerPagePagination,
  totalCountPagination,
  handleOnChangePagination,
  showLoading,
  totalCount,
  onLoadData,
  setPageSizeViewVendor
}) => {
  const columns = useMemo(() => column, []);
  const data = useMemo(() => rowsArr, [rowsArr]);
  const [checkedRows, setCheckedRows] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [isAllChecked, setIsAllChecked] = useState(false);

  const tableInstance = useTable({ columns, data }, useSortBy);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = tableInstance;

  const handleHeaderCheckboxChange = () => {
    setIsAllChecked((prev) => !prev);
    if (!isAllChecked) {
      const approvedRowIds = rows.map((row) => row.id);
      setCheckedRows(approvedRowIds);
      const selectedTotal = rows.reduce((sum, row) => sum + (row.original.TotalAmount || 0), 0);
      setTotalAmount(selectedTotal);
    } else {
      setCheckedRows([]);
      setTotalAmount(0);
    }
  };

  const handleCheckboxChange = (row) => {
    console.log(row)
    setCheckedRows((prev) => {
      let updatedCheckedRows;
      if (prev.includes(row.id)) {
        updatedCheckedRows = prev.filter((id) => id !== row.id);
      } else {
        updatedCheckedRows = [...prev, row.id];
      }
      const selectedTotal = rows.filter((r) => updatedCheckedRows.includes(r.id)).reduce((sum, r) => sum + (r.original.TotalAmount || 0), 0);
      setTotalAmount(selectedTotal);
      return updatedCheckedRows;
    });
  };

  const handleAmountChange = (row, value) => {
    row.original.amountReceived = value;
  };

  const handleDateChange = (row, value) => {
    row.original.paymentDate = value;
  };
const dispatch=useDispatch();

  const handleUpdate = () => {
    let missingAmountRows = [];
    let missingDateRows = [];
    let bothMissingRows = [];
    let validRows = [];
  
    const selectedRows = rows.filter((row) => checkedRows.includes(row.id));
  
    selectedRows.forEach((row) => {
      const { PANumber, amountReceived, paymentDate } = row.original;
  
      if (!amountReceived && !paymentDate) {
        bothMissingRows.push(PANumber);
      } else if (!amountReceived) {
        missingAmountRows.push(PANumber);
      } else if (!paymentDate) {
        missingDateRows.push(PANumber);
      } else {
        validRows.push(row.original);
      }
    });
  
    // Show alerts for missing fields
    if (bothMissingRows.length > 0) {
      toast.error(`Please enter Amount Received and Payment Date for: ${bothMissingRows.join(", ")}`);
      return;
    }
    if (missingAmountRows.length > 0) {
      toast.error(`Please enter Amount Received for: ${missingAmountRows.join(", ")}`);
      return;
    }
    if (missingDateRows.length > 0) {
      toast.error(`Please enter Payment Date for: ${missingDateRows.join(", ")}`);
      return;
    }
                            dispatch(
                              updatePaymentAdviceApi(
                                validRows,
                                (res) => {
                                    if(res?.data?.statusCode===200){
                                        setCheckedRows([]);
                                        console.log(res.data)
                                        setIsAllChecked(false)
                                        toast.success("Updated Successfully")
                                        onLoadData();
                                    }
                                },
                                () => {
                                }
                              )
                            );
  };
  
  const handlePageSizeChange=(event)=>{
    setPageSizeViewVendor(event.target.value)
    }

  return (
    <div className="card">
      <h4 className="heading me-2">Payment Advice List</h4>
      <div className="card-body">
        <div style={{display:'flex',justifyContent:'space-between'}}>
          <h4 style={{marginTop:"10px",marginRight:'10px'}}>Total Payments : &nbsp; {totalCount}</h4>
          <div className="d-flex justify-content-end">
            {checkedRows?.length !== 0 ? (
              <div style={{display:'flex',marginTop:'12px',marginRight:'10px'}}>
                <h5 style={{marginRight:'10px'}}>Selected Payments : {checkedRows?.length}</h5>
      <button
            className="btn btn-success dz-xs-flex m-r5"
            style={{ background: "rgba(233, 133, 35, 0.84)", border: "none" ,marginTop:'-10px'}}
            onClick={handleUpdate}
          >
         Update Payment Data
          </button>
              </div>
            ) : null}
          </div>
        </div>
        <br/>
        <div className="table-responsive">
          <table {...getTableProps()} className="table dataTable display">
            {!showLoading && (
              <>
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column, index) => (
                        <th {...column.getHeaderProps(column.getSortByToggleProps())} style={{ color: "rgba(23, 90, 169, 0.78)", padding: "10px 12px" }}>
                          {index === 0 ? (
                            <Checkbox
                            checked={isAllChecked}
                            onChange={handleHeaderCheckboxChange}
                            color="primary"
                          />
                          ) : (
                            <>
                              {column.render("Header")}
                              <span className="ml-1">
                                {column.isSorted ? (
                                  column.isSortedDesc ? (
                                    <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: "0.7" }} />
                                  ) : (
                                    <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: "0.7" }} />
                                  )
                                ) : (
                                  <i className="fa fa-sort ms-2 fs-14" style={{ opacity: "0.3" }} />
                                )}
                              </span>
                            </>
                          )}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {rows.map((row) => {
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell, cellIndex) => (
                          <td {...cell.getCellProps()}>
                            {cellIndex === 0 ? (
                                <Checkbox
  checked={checkedRows.includes(row.id)}
  onChange={() => handleCheckboxChange(row)}
  color="primary"
/>                            ) : cell.column.id === "AmountReceived" ? (

<>
{/* <TextField
  variant="outlined"
  size="medium"
  fullWidth
  type="string"
  value={row.original.amountReceived || ""}
  onChange={(e) => {
    let value = e.target.value;

    // Allow only numeric values using regex (but allow empty input)
    if (!/^\d*\.?\d*$/.test(value) && value !== "") return;

    let numericValue = value === "" ? "" : parseFloat(value);

    // Allow empty input
    if (value === "") {
      row.original.amountReceived = "";
      setCheckedRows((prev) => [...prev]);
      return;
    }

    // Prevent negative values
    if (numericValue < 0) {
      toast.error("Amount cannot be negative!");
      return;
    }

    // Restrict value based on the row's TotalAmount
    if (row.original.TotalAmount > 0 && numericValue > row.original.TotalAmount) {
        toast.error(`Amount recieved cannot exceed total amount`);
      return;
    }

    // Update the row data directly
    row.original.amountReceived = numericValue;

    // Force re-render by triggering state update
    setCheckedRows((prev) => [...prev]);
  }}
  InputProps={{
    startAdornment: (
      <InputAdornment position="start">
        <CurrencyRupee />
      </InputAdornment>
    ),
  }}
/> */}
<TextField
  variant="outlined"
  size="medium"
  fullWidth
  type="text"
  value={row.original.amountReceived || ""}
  onChange={(e) => {
    let value = e.target.value;

    // Allow only numbers and ONE dot
    if (!/^\d*\.?\d*$/.test(value)) return;

    // Prevent multiple dots
    if ((value.match(/\./g) || []).length > 1) return;

    // Prevent more than 2 decimal places
    if (value.includes(".") && value.split(".")[1]?.length > 2) return;

    // Convert to number for comparison (remove leading zeroes)
    let numericValue = parseFloat(value);

    // Allow empty input
    if (value === "") {
      row.original.amountReceived = "";
      setCheckedRows((prev) => [...prev]);
      return;
    }

    // Prevent negative values
    if (numericValue < 0) {
      toast.error("Amount cannot be negative!");
      return;
    }

    // Restrict value to not exceed TotalAmount
    if (numericValue > row.original.TotalAmount) {
      toast.error(`Amount received cannot exceed ₹${row.original.TotalAmount}`);
      return;
    }

    // Update state with user's input
    row.original.amountReceived = value;
    setCheckedRows((prev) => [...prev]); // Trigger re-render
  }}
  InputProps={{
    startAdornment: (
      <InputAdornment position="start">
        <CurrencyRupee />
      </InputAdornment>
    ),
  }}
/>
</>
                            ): cell.column.id === "TotalAmount" ? (
<div style={{color:'black'}}>
  {currencyFormat(row.original.TotalAmount.toFixed(2))}
</div>
                            ) : cell.column.id === "PaymentDate" ? (
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
<DatePicker
  value={row.original.paymentDate ? dayjs(row.original.paymentDate) : null}
  onChange={(newValue) => {
    if (!newValue) return;

    const selectedDate = dayjs(newValue);
    const today = dayjs();
    const fourDaysAgo = today.subtract(4, "day");

    if (selectedDate.isBefore(fourDaysAgo) || selectedDate.isAfter(today)) {
      toast.error("You can only select today or the last 4 days!");
      return;
    }

    // Store the date in ISO format
    row.original.paymentDate = selectedDate.toISOString();

    // Force re-render
    setCheckedRows((prev) => [...prev]);
  }}
  shouldDisableDate={(date) => {
    const today = dayjs();
    const fourDaysAgo = today.subtract(4, "day");
    return date.isBefore(fourDaysAgo) || date.isAfter(today);
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      size="small"
      fullWidth
      inputProps={{
        ...params.inputProps,
        readOnly: true, // Prevents manual input
      }}
    />
  )}
/>                            </LocalizationProvider>
                            ) : (
<div style={{color:'black'}}>
    {cell.render("Cell")}
</div>
                                )}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </>
            )}
            {showLoading && <SkeletonTableRow cols={4} row={4} />}
          </table>
        </div>
                           {/* Pagination & Page Size */}
                           <div className="pagination-container d-flex justify-content-between">
          <div style={{marginTop:"20px"}}>
            <label htmlFor="pageSizeSelect">Rows per page: </label>
            <select
              id="pageSizeSelect"
              value={pageSizePagination}
              onChange={handlePageSizeChange}
              style={{ marginLeft: "10px" }}
            >
                  <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={250}>250</option>
              <option value={500}>500</option>
            </select>
          </div>
          <PaginationAndSearching
                handleSearch={handleSearchPagination}
                searchValue={searchValuePagination}
                defaultValue={pageSizePagination}
                handleChangeRowsPerPage={handleChangeRowsPerPagePagination}
                totalCount={totalCountPagination}
                onChange={(e,p)=>{
                  handleOnChangePagination(e,p)
                  setCheckedRows([])
                }}
              />
            </div>      </div>
    </div>
  );
};

export default PaymentAdviceTable;
